import { Outlet, useLocation } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';

import { AppSidebar } from './Privatize/navbar/AppSidebar';
import { CommandPalette } from '@/components/CommandPalette';
import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary';
import { UserContext } from 'contexts';
import { useAuth } from 'contexts/AuthContext';
import { AccessDenied } from 'components/AccessDenied';
import { canAccessPage, findPageForPath } from 'hooks/useHasPermission';

export function PrivateLayout() {
    const { user } = useAuth();
    const { pathname } = useLocation();

    // AuthGuard guarantees user is non-null here
    if (!user) return null;

    // Un seul garde pour toutes les routes privées : la page servie à cette adresse porte son droit.
    const page = findPageForPath(pathname);
    const isDenied = !!page && !canAccessPage(page, user.effectivePermissions);

    return (
        <UserContext.Provider value={user}>
            <TooltipProvider>
                <SidebarProvider>
                    <AppSidebar />
                    <CommandPalette />
                    <SidebarInset key={pathname} className="h-svh overflow-y-auto">
                        <ErrorBoundary>
                            {isDenied && page ? (
                                <AccessDenied
                                    pageLabel={page.label}
                                    requiredPermissions={[
                                        ...(page.permission ? [page.permission] : []),
                                        ...(page.alsoRequires ?? []),
                                    ]}
                                />
                            ) : (
                                <Outlet />
                            )}
                        </ErrorBoundary>
                    </SidebarInset>
                </SidebarProvider>
            </TooltipProvider>
        </UserContext.Provider>
    );
}
